import EditProfileContainer from "../../../components/applications/users/editProfile";

const EditProfile = () => {
  return <EditProfileContainer />;
};

export default EditProfile;
